<script lang="ts">
	export let blok;
</script>

<div class="bg-special-danger text-white text-h-32 px-9 w-full py-16">
	I am a placeholder for {blok.component}
</div>
